import {FC, useState} from 'react';
import dayjs from 'dayjs';

import TableRow from '@mui/material/TableRow';
import TableCell, {TableCellProps} from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Status from '../../../../../../ui/status/Status';
import {Box, Collapse, IconButton, Stack, styled, Typography} from '@mui/material';

import {IServiceRequestStatusHistory} from '../../../../../../shared/types/serviceRequest.types';
import {colors} from '../../../../../../shared/colors';
import {DATETIME_FORMAT} from '../../../../../../shared/constants';
import {getCodeWithArchivedStatus} from '../../../../../../shared/helpers/getCodeWithArchivedStatus';

interface IStatusHistoryRow {
  row: IServiceRequestStatusHistory;
}

const BorderlessTableCell = styled(TableCell)<TableCellProps>(({theme}) => ({
  '.MuiTableCell-root:not(.MuiTableCell-root + .MuiTableRow-root)': {
    borderBottom: 0,
  },
}));

export const StatusHistoryRow: FC<IStatusHistoryRow> = ({row}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow hover>
        <BorderlessTableCell sx={{width: '34px', padding: '0 0 0 16px'}}>
          <IconButton
            aria-label="expand row"
            size="small"
            sx={{height: 25, width: 25}}
            disabled={!row.reasonStatusCodeChanged}
            onClick={(e) => {
              e.stopPropagation();
              setOpen((prev) => !prev);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </BorderlessTableCell>
        <TableCell scope="row" align="left">
          {row.author ? `${row.author.firstName} ${row.author.lastName}` : '-'}
        </TableCell>
        <TableCell align="center">{dayjs(row.date).format(DATETIME_FORMAT)}</TableCell>
        <TableCell align="center">
          <Status
            sx={{fontSize: '12px'}}
            variant="subtitle2"
            border={row.archived}
            entity="serviceRequest"
            code={getCodeWithArchivedStatus(row.statusCode, row.archived)}
          />
        </TableCell>
      </TableRow>
      {row.reasonStatusCodeChanged ? (
        <TableRow sx={{backgroundColor: colors['bg--on-white']}}>
          <BorderlessTableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{margin: 1}}>
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{
                    margin: 1,
                  }}
                >
                  <Typography component="div" marginRight={2} variant="subtitle2" fontWeight={500}>
                    {'Комментарий: '}
                  </Typography>
                  <Typography
                    component="div"
                    sx={{wordBreak: 'break-all'}}
                    flexWrap="wrap"
                    variant="subtitle2"
                    fontWeight={400}
                  >
                    {row.reasonStatusCodeChanged}
                  </Typography>
                </Stack>
              </Box>
            </Collapse>
          </BorderlessTableCell>
        </TableRow>
      ) : null}
    </>
  );
};
